import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ROOT_URL, TOKEN } from '../../config';

export default class Team extends Component {
  state = {
    data: '',
    loading: true,
  }

  componentDidMount() {
    axios.get(`${ROOT_URL}/cockpit-master/api/collections/get/Team?token=${TOKEN}`, {
    method: 'GET',
    authorization: 'basic',
    headers: { 'Content-Type': 'application/json', /*'Access-Control-Allow-Origin': '*'*/ },
  })
    .then(res => this.setState({
      data: res.data,
      loading: false
    }))
  }

  renderHelper() {
    const { entries } = this.state.data;
    return(
      entries.map((entrie, i) => {
        return (
          <div  key={entrie.id} className="column col-6">
            <div className="item card">
              <div className="overflow-hidden-2">
                <Link to={`/kontakt/${entrie.id}`}><img alt-text="" src={ROOT_URL + entrie.image.path}/></Link>
              </div>
              <div className="container">
                <h2 className="effect container">{entrie.titel}</h2>
                <p className="effect">{entrie.beschreibung}</p>
                <p className="effect"><a href={`mailto:${entrie.email}`}>{entrie.email}</a> <br /> {entrie.tel}</p>
              </div>
            </div>
          </div>
        );
      })
    );
  }

  render() {
    if(this.state.loading) {
      return (
        <div className="container fullScreen">

        </div>
      );
    } else {
      return(
        <div className="container nop fullScreen">
          <div className="container">
            <h1 className="effect container">Team</h1>
          </div>
          <div className="row col-12 pdt nop">
            {this.renderHelper()}
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/team.js